import React, { useState, forwardRef, useEffect, useImperativeHandle, useRef } from "react";

import { Dropdown } from "primereact/dropdown";
import levelsAPI from "../../../../services/levels";
import classesAPI from "../../../../services/classes";
import { Dialog } from "primereact/dialog";
import MeaButton from "../../../../components/MeaButton";
import tasksAPI from "../../../../services/tasks";
import { Toast } from "primereact/toast";

const UpdateRegistrationAffectationModal = forwardRef((props, ref) => {
  //
  const schoolId = props?.schoolId;
  const trainingId = props?.trainingId;
  const accessToken = "";
  //
  const [studentsIds, setStudentsIds] = useState([]);
  const [levelId, setLevelId] = useState("");
  const [classId, setClassId] = useState("");
  //

  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [callbackFn, setCallbackFn] = useState(() => { });
  const toast = useRef(null);
  //
  //
  const levelsQuery = levelsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000
  );
  const classesQuery = classesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000,
    {
      level_id: levelId,
    }
  );
  //
  useImperativeHandle(ref, () => ({
    show: (students_ids, callback) => {
      setClassId(null);
      setLevelId(null);
      setStudentsIds(students_ids);
      setCallbackFn(() => callback);
      setActive(true);
    },
  }));
  //
  const footerContent = (
    <div>
      <MeaButton
        label="Annuler"
        icon="pi pi-times"
        disabled={loading}
        loading={loading}
        onClick={() => setActive(false)}
        className="p-button-text"
      />
      <MeaButton
        type="submit"
        loading={loading}
        disabled={!classId}
        label="Enregister"
        icon="pi pi-save"
        onClick={() => handleUpdateSubmit()}
      />
    </div>
  );
  //
  const handleUpdateSubmit = async (e) => {
    // Handle update action
    setLoading(true);
    const studentIdsArray = studentsIds?.map(student => student.id);

    tasksAPI
      .UpdateStudentsClass(schoolId, trainingId, accessToken, {
        students_ids: studentIdsArray,
        new_class_id: classId,
      })
      .then((data) => {

        setJobId(data?.data?.id);
        //
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Erreur de modification!",
        });
        setJobId(null);
        setActive(false);
        setLoading(false);
        //callbackFn();
      })
  };
  //
  const [jobId, setJobId] = useState(null);
  useEffect(() => {
    const fetchTaskStatus = async () => {
      tasksAPI.GetTask(schoolId, trainingId, jobId, "")
        .then((data) => {
          if (data?.data?.status === "COMPLETED") {
            {
              toast.current.clear();
              toast.current.show({ severity: 'success', summary: 'Succès', detail: 'Traitement fini' });
              setJobId(null);
              setActive(false);
              setLoading(false);
              callbackFn();
            }
          } else if (data?.data?.status === "FAILED") {
            {
              toast.current.clear();
              toast.current.show({ severity: 'error', summary: 'Erreur', detail: 'Error lors du traitement!' });
              setJobId(null);
              setActive(false);
              setLoading(false);
              //callbackFn();
            }
          }
          else {
            setTimeout(fetchTaskStatus, 1000); // Retry after 1 seconds
          }
        })
        .catch((error) => {
          console.log("error " + error);
          setJobId(null);
          setActive(false);
          setLoading(false);
        });
    };

    if (jobId) {
      fetchTaskStatus();
    }

  }, [jobId]);
  //
  return (
    <>
      <Toast ref={toast} position="bottom-center" />
      <Dialog
        focusOnShow={false}
        header="Affectation à une classe"
        visible={active}
        style={{ width: "30vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        onHide={() => setActive(false)}
        footer={footerContent}
      >
        <div className="w-full">
          <div className="flex flex-column gap-2">
            <label htmlFor="level" className="block text-900 mt-4 font-medium mb-2">
              Niveau
            </label>
            <Dropdown
              value={levelsQuery?.data?.data?.find((obj) => obj.id === levelId)}
              onChange={(e) => setLevelId(e.value?.id)}
              options={levelsQuery?.data?.data}
              optionLabel="name"
              className="w-full mb-3"
            />
            <label htmlFor="classe" className="block text-900 font-medium mb-2">
              Classe
            </label>
            <Dropdown
              disabled={
                levelId === null || levelId === undefined || levelId === ""
              }
              value={classesQuery?.data?.data?.find(
                (obj) => obj.id === classId
              )}
              onChange={(e) => setClassId(e.value?.id)}
              options={classesQuery?.data?.data}
              optionLabel="name"
              className="w-full mb-3"
            />
          </div>
        </div>
      </Dialog>
    </>
  );
});

export default UpdateRegistrationAffectationModal;
